export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigung"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stornieren"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ja"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sind Sie sicher, dass Sie fortfahren möchten?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Krypto-Asset löschen"])}
}